import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GetFolderImages from './components/GetFolderImages';
import CollectionPhotos from './components/CollectionPhotos';
import UploadImages from './components/UploadImages';
import Ingest from './components/Ingest';
import UserManager from './components/UserManager';
import DisableRightClick from './components/DisableRightClick';
import { UserProvider } from './context/UserContext';
import ProtectedRoute from './components/ProtectedRoute';
import IptcSearch from './components/IptcSearch';
import UserProfile from './components/UserProfile';
import AdminOrders from './components/AdminOrders';
import Settings from './components/Settings';
import Contact from './components/Contact';
import ZoomSafeComponent from './components/ZoomSafeComponent';
import Navbar from './components/Navbar';
import Collections from './components/Collections';
import Footer from './components/Footer';
import { SettingsProvider, useSettings } from './context/SettingsContext';  // Importa l'hook dei settings
import GetFrontPageThumbnails from './components/GetFrontPageThumbnails';
import SiteMaintenance from './components/SiteMaintenance';
import CollectionsEditor from './components/CollectionsEditor';
import SavedSearchesEditor from './components/SavedSearchesEditor';
import SliderEditor from './components/SliderEditor';
import CookieBanner from './components/CookieBanner';
import { useUser } from './context/UserContext';  // assicurati che sia importato
import AnalyticsTracker from './components/AnalyticsTracker';
import SliderShow from './components/SliderShow';

function AntitheftWrapper({ enabled, children }) {
  if (!enabled) return <>{children}</>;
  return (
    <DisableRightClick>
      <ZoomSafeComponent>{children}</ZoomSafeComponent>
    </DisableRightClick>
  );
}

function AppContent() {
  const { settings, loading  } = useSettings();  // Usa l'hook per ottenere le impostazioni
  const { cookieConsent, giveCookieConsent } = useUser();
  
  if (loading) 
    return null;

  return (
    <AntitheftWrapper enabled={!!(settings && settings.enableAntitheft)}>
      <Router>
        <AnalyticsTracker /> {/* <-- Questo monitora ogni cambio pagina */}
        <Navbar />
        <Routes>
          <Route path='/' element={
            !settings.disableSite ? (
              <div>
                {settings.showSlider && <SliderShow interval={4000} />}
                <Collections /> 
                <GetFrontPageThumbnails />
              </div>
            ) : (<SiteMaintenance />)
          } />
          <Route path='/gallery/:folderName' element={<GetFolderImages />} />
          <Route path='/collection/:id' element={<CollectionPhotos />} />
          <Route path='/search' element={<IptcSearch />} />
          <Route path='/profile' element={<UserProfile />} />
          <Route path='/contact' element={<Contact />} />

          {/* Rotte protette per amministratori */}
          <Route
            path='/uploadimages'
            element={
              <ProtectedRoute allowedRoles={['administrator']}>
                <UploadImages />
              </ProtectedRoute>
            }
          />
          <Route
            path='/ingest'
            element={
              <ProtectedRoute allowedRoles={['administrator']}>
                <Ingest />
              </ProtectedRoute>
            }
          />
          <Route
            path='/usermanager'
            element={
              <ProtectedRoute allowedRoles={['administrator']}>
                <UserManager />
              </ProtectedRoute>
            }
          />
          <Route
            path='/adminorders'
            element={
              <ProtectedRoute allowedRoles={['administrator']}>
                <AdminOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path='/settings'
            element={
              <ProtectedRoute allowedRoles={['administrator']}>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path='/collectionseditor'
            element={
              <ProtectedRoute allowedRoles={['administrator']}>
                <CollectionsEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path='/savedsearcheseditor'
            element={
              <ProtectedRoute allowedRoles={['administrator']}>
                <SavedSearchesEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path='/slidereditor'
            element={
              <ProtectedRoute allowedRoles={['administrator']}>
                <SliderEditor />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Footer />
        <CookieBanner consentGiven={cookieConsent} giveCookieConsent={giveCookieConsent} />
      </Router>
    </AntitheftWrapper>
  );
}

function App() {
  return (
    <SettingsProvider>
      <UserProvider>
        <AppContent />
      </UserProvider>
    </SettingsProvider>
  );
}

export default App;
